export enum CONTEST_UPGRADES {
  featured = 'featured',
  sealed = 'sealed',
  highlight = 'highlight',
  guaranteed = 'guaranteed',
  topContest = 'topContest',
  NDA = 'NDA',
  urgent = 'urgent',
}

export enum PROJECT_TYPES {
  fixed = 'fixed',
  hourly = 'hourly',
}

export enum PROJECT_UPGRADES {
  featured = 'featured',
  sealed = 'sealed',
  NDA = 'NDA',
  urgent = 'urgent',
  // TODO: T265379 Remove fulltime when FULLTIME gets removed from SearchFiltersProjectUpgradeApi enum
  fulltime = 'fulltime',
  assisted = 'assisted', // `recruiter` exists in the API, but `assisted` is the proper filter
  ip_agreement = 'ip_agreement',
}

export enum ContestFilters {
  PRIZE_MAX = 'prizeMax',
  PRIZE_MIN = 'prizeMin',
  SKILLS = 'contestSkills',
  SORTING = 'contestSort',
  UPGRADES = 'contestUpgrades',
}

export enum ContestSortingOptions {
  LATEST = 'latest',
  OLDEST = 'oldest',
  LOWEST_PRIZE = 'lowestPrize',
  HIGHEST_PRIZE = 'highestPrize',
  FEWEST_ENTRIES = 'fewestEntries',
  MOST_ENTRIES = 'mostEntries',
}

export enum DriverFilters {
  LOAD_TYPE = 'loadType',
  TRUCK_TYPE = 'truckType',
  LOCATION = 'driverLocation',
  RATING = 'rating',
}

export enum LoadFilters {
  ADMINISTRATIVE_AREAS_END = 'loadAdministrativeAreasEnd',
  ADMINISTRATIVE_AREAS_START = 'loadAdministrativeAreasStart',
  LOAD_TYPES = 'loadTypes',
  OPERATING_AREAS_END = 'loadOperatingAreasEnd',
  OPERATING_AREAS_START = 'loadOperatingAreasStart',
}

export enum ProjectFilters {
  CLIENT_COUNTRIES = 'clientCountries',
  FIXED_PRICE_MAX = 'projectFixedPriceMax',
  FIXED_PRICE_MIN = 'projectFixedPriceMin',
  HOURLY_RATE_MAX = 'projectHourlyRateMax',
  HOURLY_RATE_MIN = 'projectHourlyRateMin',
  LANGUAGES = 'projectLanguages',
  LOCATION = 'projectLocation',
  SKILLS = 'projectSkills',
  SORTING = 'projectSort',
  TYPES = 'types',
  UPGRADES = 'projectUpgrades',
}

export enum ProjectSortingOptions {
  LATEST = 'latest',
  OLDEST = 'oldest',
  LOWEST_PRICE = 'lowestPrice',
  HIGHEST_PRICE = 'highestPrice',
  FEWEST_BIDS = 'fewestBids',
  MOST_BIDS = 'mostBids',
}

export enum SearchType {
  CONTESTS = 'contests',
  PROJECTS = 'projects',
  SHARED = 'shared',
  USERS = 'users',
  FREIGHTLANCER_DRIVERS = 'freightlancerDrivers',
  FREIGHTLANCER_LOADS = 'freightlancerLoads',
  DELOITTE_USERS = 'deloitteUsers',
}

export enum SharedFilters {
  PAGE = 'page',
  POOLS = 'pools',
  QUERY = 'q',
}

export enum SortingOptionType {
  CONTESTS,
  PROJECTS,
  USERS,
}

export enum UserFilters {
  COUNTRIES = 'userCountries',
  EXAMS = 'exams',
  HOURLY_RATE_MAX = 'hourlyRateMax',
  HOURLY_RATE_MIN = 'hourlyRateMin',
  ONLINE = 'online',
  RATING = 'rating',
  REVIEW_COUNT_MAX = 'reviewCountMax',
  REVIEW_COUNT_MIN = 'reviewCountMin',
  SKILLS = 'userSkills',
}

export enum UserSortingOptions {
  MOST_RELEVANT,
  HOURLY_RATE_LOW_TO_HIGH,
  HOURLY_RATE_HIGH_TO_LOW,
}

export enum DeloitteUserFilters {
  CERTIFICATIONS = 'certifications',
  COUNTRY_ALIGNMENT = 'countryAlignment',
  GIG_WORKER_LEVEL = 'level',
  INDEPENDENCE_RULESET = 'independenceRuleset',
  LEGAL_ENTITY = 'legalEntity',
  LOCATION = 'location',
  MEMBER_FIRM_ALIGNMENT = 'memberFirmAlignment',
  OFFERING_PORTFOLIO = 'offeringPortfolio',
  PRACTICE = 'practice',
}

export interface LocationFilter {
  readonly country?: string;
  readonly fullAddress: string;
  readonly latitude: number;
  readonly longitude: number;
}

export interface ContestFilterType {
  readonly [ContestFilters.PRIZE_MAX]?: number;
  readonly [ContestFilters.PRIZE_MIN]?: number;
  readonly [ContestFilters.SKILLS]: readonly FilterArrayItem<number>[];
  readonly [ContestFilters.SORTING]?: ContestSortingOptions;
  readonly [ContestFilters.UPGRADES]: readonly FilterArrayItem<CONTEST_UPGRADES>[];
}

export interface FreightlancerDriverFilterType {
  // TODO: T267853 - Uncomment [DriverFilters.LOAD_TYPE] and [DriverFilters.TRUCK_TYPE]
  // once they have been integrated with the search filters service

  // readonly [DriverFilters.LOAD_TYPE]: readonly FilterArrayItem<string>[];
  readonly [DriverFilters.LOCATION]?: LocationFilter;
  readonly [DriverFilters.RATING]?: number;
  // readonly [DriverFilters.TRUCK_TYPE]: readonly FilterArrayItem<string>[];
}

export interface FreightlancerLoadFilterType {
  readonly [LoadFilters.ADMINISTRATIVE_AREAS_END]: readonly FilterArrayItem<string>[];
  readonly [LoadFilters.ADMINISTRATIVE_AREAS_START]: readonly FilterArrayItem<string>[];
  readonly [LoadFilters.LOAD_TYPES]: readonly FilterArrayItem<number>[];
  readonly [LoadFilters.OPERATING_AREAS_END]: readonly FilterArrayItem<number>[];
  readonly [LoadFilters.OPERATING_AREAS_START]: readonly FilterArrayItem<number>[];
}

export interface ProjectFilterType {
  readonly [ProjectFilters.CLIENT_COUNTRIES]: readonly FilterArrayItem<string>[];
  readonly [ProjectFilters.FIXED_PRICE_MAX]?: number;
  readonly [ProjectFilters.FIXED_PRICE_MIN]?: number;
  readonly [ProjectFilters.HOURLY_RATE_MAX]?: number;
  readonly [ProjectFilters.HOURLY_RATE_MIN]?: number;
  readonly [ProjectFilters.LANGUAGES]: readonly FilterArrayItem<string>[];
  readonly [ProjectFilters.LOCATION]?: LocationFilter;
  readonly [ProjectFilters.SKILLS]: readonly FilterArrayItem<number>[];
  readonly [ProjectFilters.SORTING]?: ProjectSortingOptions;
  readonly [ProjectFilters.TYPES]: readonly FilterArrayItem<PROJECT_TYPES>[];
  readonly [ProjectFilters.UPGRADES]: readonly FilterArrayItem<PROJECT_UPGRADES>[];
}

export interface SharedFilterType {
  readonly [SharedFilters.PAGE]?: number;
  readonly [SharedFilters.POOLS]: readonly FilterArrayItem<number>[];
  readonly [SharedFilters.QUERY]: string;
}

export interface DeloitteUserFilterType {
  readonly [DeloitteUserFilters.CERTIFICATIONS]: readonly FilterArrayItem<string>[];
  readonly [DeloitteUserFilters.COUNTRY_ALIGNMENT]: readonly FilterArrayItem<string>[];
  readonly [DeloitteUserFilters.GIG_WORKER_LEVEL]: readonly FilterArrayItem<string>[];
  readonly [DeloitteUserFilters.INDEPENDENCE_RULESET]: readonly FilterArrayItem<string>[];
  readonly [DeloitteUserFilters.LEGAL_ENTITY]: readonly FilterArrayItem<string>[];
  readonly [DeloitteUserFilters.LOCATION]?: LocationFilter;
  readonly [DeloitteUserFilters.MEMBER_FIRM_ALIGNMENT]: readonly FilterArrayItem<string>[];
  readonly [DeloitteUserFilters.OFFERING_PORTFOLIO]: readonly FilterArrayItem<string>[];
  readonly [DeloitteUserFilters.PRACTICE]: readonly FilterArrayItem<string>[];
}

export interface UserFilterType {
  readonly [UserFilters.COUNTRIES]: readonly FilterArrayItem<string>[];
  readonly [UserFilters.EXAMS]: readonly FilterArrayItem<number>[];
  readonly [UserFilters.HOURLY_RATE_MAX]?: number;
  readonly [UserFilters.HOURLY_RATE_MIN]?: number;
  readonly [UserFilters.ONLINE]?: boolean;
  readonly [UserFilters.RATING]?: number;
  readonly [UserFilters.REVIEW_COUNT_MAX]?: number;
  readonly [UserFilters.REVIEW_COUNT_MIN]?: number;
  readonly [UserFilters.SKILLS]: readonly FilterArrayItem<number>[];
}

export interface SearchFilters {
  readonly [SearchType.USERS]?: UserFilterType;
  readonly [SearchType.PROJECTS]?: ProjectFilterType;
  readonly [SearchType.CONTESTS]?: ContestFilterType;
  readonly [SearchType.SHARED]?: SharedFilterType;
  readonly [SearchType.FREIGHTLANCER_DRIVERS]?: FreightlancerDriverFilterType;
  readonly [SearchType.FREIGHTLANCER_LOADS]?: FreightlancerLoadFilterType;
  readonly [SearchType.DELOITTE_USERS]?: DeloitteUserFilterType;
}

export const ARRAY_FILTERS = [
  ContestFilters.SKILLS,
  ContestFilters.UPGRADES,
  DeloitteUserFilters.CERTIFICATIONS,
  DeloitteUserFilters.COUNTRY_ALIGNMENT,
  DeloitteUserFilters.GIG_WORKER_LEVEL,
  DeloitteUserFilters.INDEPENDENCE_RULESET,
  DeloitteUserFilters.LEGAL_ENTITY,
  DeloitteUserFilters.MEMBER_FIRM_ALIGNMENT,
  DeloitteUserFilters.OFFERING_PORTFOLIO,
  DeloitteUserFilters.PRACTICE,
  DriverFilters.LOAD_TYPE,
  DriverFilters.TRUCK_TYPE,
  LoadFilters.ADMINISTRATIVE_AREAS_END,
  LoadFilters.ADMINISTRATIVE_AREAS_START,
  LoadFilters.LOAD_TYPES,
  LoadFilters.OPERATING_AREAS_END,
  LoadFilters.OPERATING_AREAS_START,
  ProjectFilters.CLIENT_COUNTRIES,
  ProjectFilters.LANGUAGES,
  ProjectFilters.SKILLS,
  ProjectFilters.TYPES,
  ProjectFilters.UPGRADES,
  SharedFilters.POOLS,
  UserFilters.COUNTRIES,
  UserFilters.EXAMS,
  UserFilters.SKILLS,
] as const;
export type ArrayTypeFilter = typeof ARRAY_FILTERS[number];

export type FilterValue = string | boolean | number | object | undefined;

export interface FilterArrayItem<T> {
  selected: boolean;
  value: T;
}

export type FilterArrayItemValue<T, K extends keyof T> = (T[K] &
  FilterArrayItem<unknown>)['value'];

export type FilterValueType<
  T,
  K extends keyof T
> = T[K] extends FilterArrayItem<unknown>[]
  ? readonly FilterArrayItem<FilterArrayItemValue<T, K>>[]
  : FilterValue;

export const FILTER_NAMES = {
  [SearchType.USERS]: Object.values(UserFilters),
  [SearchType.PROJECTS]: Object.values(ProjectFilters),
  [SearchType.CONTESTS]: Object.values(ContestFilters),
  [SearchType.SHARED]: Object.values(SharedFilters),
  [SearchType.FREIGHTLANCER_DRIVERS]: Object.values(DriverFilters),
  [SearchType.DELOITTE_USERS]: Object.values(DeloitteUserFilters),
};

export const DEFAULT_FILTER_VALUES = {
  [ContestFilters.PRIZE_MAX]: undefined,
  [ContestFilters.PRIZE_MIN]: 0,
  [ContestFilters.SKILLS]: [],
  [ContestFilters.SORTING]: undefined,
  [ContestFilters.UPGRADES]: [],
  [DriverFilters.LOAD_TYPE]: [],
  [DriverFilters.LOCATION]: undefined,
  [DriverFilters.RATING]: 0,
  [DriverFilters.TRUCK_TYPE]: [],
  [LoadFilters.ADMINISTRATIVE_AREAS_END]: [],
  [LoadFilters.ADMINISTRATIVE_AREAS_START]: [],
  [LoadFilters.LOAD_TYPES]: [],
  [LoadFilters.OPERATING_AREAS_END]: [],
  [LoadFilters.OPERATING_AREAS_START]: [],
  [ProjectFilters.CLIENT_COUNTRIES]: [],
  [ProjectFilters.FIXED_PRICE_MAX]: undefined,
  [ProjectFilters.FIXED_PRICE_MIN]: 0,
  [ProjectFilters.HOURLY_RATE_MAX]: undefined,
  [ProjectFilters.HOURLY_RATE_MIN]: 0,
  [ProjectFilters.LANGUAGES]: [],
  [ProjectFilters.LOCATION]: undefined,
  [ProjectFilters.SKILLS]: [],
  [ProjectFilters.SORTING]: undefined,
  [ProjectFilters.TYPES]: [],
  [ProjectFilters.UPGRADES]: [],
  [SharedFilters.PAGE]: 1,
  [SharedFilters.QUERY]: '',
  [SharedFilters.POOLS]: [],
  [UserFilters.COUNTRIES]: [],
  [UserFilters.EXAMS]: [],
  [UserFilters.HOURLY_RATE_MAX]: undefined,
  [UserFilters.HOURLY_RATE_MIN]: 0,
  [UserFilters.ONLINE]: undefined,
  [UserFilters.RATING]: 0,
  [UserFilters.REVIEW_COUNT_MAX]: undefined,
  [UserFilters.REVIEW_COUNT_MIN]: 0,
  [UserFilters.SKILLS]: [],
  [DeloitteUserFilters.CERTIFICATIONS]: [],
  [DeloitteUserFilters.COUNTRY_ALIGNMENT]: [],
  [DeloitteUserFilters.GIG_WORKER_LEVEL]: [],
  [DeloitteUserFilters.INDEPENDENCE_RULESET]: [],
  [DeloitteUserFilters.LEGAL_ENTITY]: [],
  [DeloitteUserFilters.LOCATION]: undefined,
  [DeloitteUserFilters.MEMBER_FIRM_ALIGNMENT]: [],
  [DeloitteUserFilters.PRACTICE]: [],
  [DeloitteUserFilters.OFFERING_PORTFOLIO]: [],
};

/**
 * Extend this type with the other filter types as they become available:
 * export type FilterTypes = ProjectFilterType | ContestFilterType | UserFilterType;
 */
export type FilterTypes =
  | UserFilterType
  | ProjectFilterType
  | ContestFilterType
  | SharedFilterType
  | FreightlancerDriverFilterType
  | FreightlancerLoadFilterType
  | DeloitteUserFilterType;

export type FilterStateSnapshot<T extends FilterTypes> = Partial<
  SharedFilterType & T
>;

export type Filters =
  | UserFilters
  | ProjectFilters
  | ContestFilters
  | SharedFilters
  | DriverFilters
  | DeloitteUserFilters
  | LoadFilters;
